exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".row{border-bottom:1px dotted #242424;padding:2em 0}.row>.row{padding:0}.row:last-child{border:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./~/postcss-loader!./app/src/Home/components/stylesheets/IndexComponent.scss
// module id = 451
// module chunks = 0